import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=24b450c0&scoped=true&"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceStatistics.vue?vue&type=style&index=0&id=24b450c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b450c0",
  null
  
)

export default component.exports